import React, { useContext, useState } from 'react';
import Image from 'react-bootstrap/Image';
import Logo from '../../../margretlogo.png';
import Button from 'react-bootstrap/Button'
import Table from 'react-bootstrap/Table';
import { Col, Container, Row } from 'react-bootstrap';
import { GlobalContext } from '../../context/provider';
import moment from "moment";
import '../css/onprinttoggle.css';
import numberbeautifuly from '../../../utils/numberbeautify';

const Expense_report_detail_print = props => {
    const { reportState, reportDispatch } = useContext(GlobalContext);
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    return (
        <div className='print_show'>
            <Container>
                <Row className='justify-content-md-center mt-3'>
                    <Image src={Logo} style={{ width: 110, height: 100 }} />
                    <center><span>لیستی خەرجی ڕادیۆی مارگرێت لە بەرواری {moment(props.from).format('YYYY-MM-DD')} بۆ بەرواری {moment(props.to).format('YYYY-MM-DD')}</span></center>
                </Row>
                <Row className='justify-content-md-center mt-4'>
                    <table>
                        <thead style={{ border: '2px solid', textAlign: 'center' }}>
                            <tr style={{ border: '2px solid', textAlign: 'center' }}>
                                <th>ناوی کەس و مەبەستی خەرجی</th>
                                <th>بڕ</th>
                                <th>شوێن و جۆری خەرجی</th>
                                <th>بەروار</th>
                                <th>تێبینی</th>
                            </tr>
                        </thead>
                        <tbody style={{ border: '2px solid', textAlign: 'center', fontSize: 12 }}>
                            {reportState.expense.map((lis) => (
                                <tr style={{ border: '2px solid', textAlign: 'center' }}>
                                    <td>{lis.radio_expense_name}</td>
                                    <td>{numberbeautifuly(lis.radio_expense_amount)} IQD</td>
                                    <td>{lis.project_expense_type}</td>
                                    <td>{moment(lis.radio_expense_date).format('YYYY-MM-DD')}</td>
                                    <td>{lis.radio_expense_note}</td>
                                </tr>
                            ))}
                            <tr style={{ border: '2px solid', textAlign: 'center' }}>
                                <td>کۆی خەرجی</td>
                                <td colSpan={4} style={{ textAlign: 'center' }}>{numberbeautifuly(reportState.total_expense)} IQD</td>
                            </tr>
                        </tbody>
                    </table>
                </Row>
                <div style={{ width: '100%', marginTop: '5vh', display: 'flex', justifyContent: 'space-between' }}>
                    <div style={{ width: '50%' }}>
                        <span>سارا سعدی عمر<br />
                            ژمێریار</span>
                    </div>
                    <div style={{ width: '50%', display: 'flex', justifyContent: "flex-end" }}>
                        <span>ئاڤان ئەحمەد حەمە<br />
                            بەڕێوەبەر</span>
                    </div>
                </div>
            </Container>
        </div>
    )
}

export default Expense_report_detail_print